// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uac-page-grid {
    display: grid;
    grid-template-areas: 
        "left middle";
    grid-template-rows: 80px auto;  /* Header + Content */
    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */
    height: 750px;
    width: 1230px;
    gap: 15px;
    padding: 10px;
    max-height: 100vh;       /* Prevent vertical overflow */
    overflow: hidden;       /* Hide overflowing content */
    box-sizing: border-box; /* Include padding & border in width/height */
    display: flex;          /* Use flexbox for better responsiveness */
    flex-direction: row;
    flex-wrap: nowrap; /* Prevents elements from wrapping */
    align-items: flex-start;
    position: fixed;
    margin-top: 30px;
    background: rgb(34, 31, 31);
    border-radius: 20px;
  }
  
  /* Right Sidebar */
  .uac-left-sidebar-container {
    grid-area: left;
    border-radius: 10px;
    margin-top: -10px;
    margin-left: 10px;
    height: 750px;
    max-height: 1000vh;
    width: 500px;
    position: fixed;
    background: black;
  
    /* ✅ boundary line */
    border: 2px solid white;
  
    /* optional glow effect */
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.4);
  }
  
  .uac-popover-middle-container {
    /* grid-area: middle; */
    grid-template-rows: 80px auto;  /* Header + Content */
    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */
    background: none;
    margin-top: -10px;
    width: 670px;
    height: 750px;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    margin-left: 520px;
    position: fixed;
    background: black;
  }
    
    /* Responsive Design */
    @media (max-width: 900px) {
      .page-grid {
        grid-template-areas:
          "top"
          "middle"
          "left"
          "right";
        grid-template-columns: 1fr;
        grid-template-rows: 80px auto auto auto;
      }
    }

    /* Profile Section - Fixed at the Top */
.uac-profile-section {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: left;
  border-radius: 10px;
  margin-top: 0px;
  background: none;
  margin-left: 20px;
}

/* Profile Picture */
.uac-profile-pic {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: 10px;
  margin-top: 20px;
}

/* User Name */
.uml-profile-name {
  font-size: 20px;
  font-weight: normal;
  margin-left: 20px;
  margin-top: 30px;
}

/* Search Bar */
.uac-search-bar {
  width: 500px;
  padding: 10px;
  background: none;
  border-bottom: 1px solid #ddd;
}

.uac-conversations-history {
  /* flex: 1; */
  overflow-y: scroll;
  padding: 16px;
  height: 560px;
  border-radius: 10px;
  border-right: 2px solid darkslategray;
}

/* Input Box */
.uac-message-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* padding: 10px; */
  border-top: 1px solid #ccc;
  background: none;
  margin-bottom: 100px;
  width: 670px;
  height: 130px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Styles/uac-common-styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb;qBACiB;IACjB,6BAA6B,GAAG,qBAAqB;IACrD,6CAA6C,EAAE,mCAAmC;IAClF,aAAa;IACb,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB,QAAQ,8BAA8B;IACvD,gBAAgB,QAAQ,6BAA6B;IACrD,sBAAsB,EAAE,6CAA6C;IACrE,aAAa,WAAW,0CAA0C;IAClE,mBAAmB;IACnB,iBAAiB,EAAE,oCAAoC;IACvD,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;;IAEjB,oBAAoB;IACpB,uBAAuB;;IAEvB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,uBAAuB;IACvB,6BAA6B,GAAG,qBAAqB;IACrD,6CAA6C,EAAE,mCAAmC;IAClF,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;IAEE,sBAAsB;IACtB;MACE;QACE;;;;iBAIS;QACT,0BAA0B;QAC1B,uCAAuC;MACzC;IACF;;IAEA,uCAAuC;AAC3C;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EAEX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".uac-page-grid {\n    display: grid;\n    grid-template-areas: \n        \"left middle\";\n    grid-template-rows: 80px auto;  /* Header + Content */\n    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */\n    height: 750px;\n    width: 1230px;\n    gap: 15px;\n    padding: 10px;\n    max-height: 100vh;       /* Prevent vertical overflow */\n    overflow: hidden;       /* Hide overflowing content */\n    box-sizing: border-box; /* Include padding & border in width/height */\n    display: flex;          /* Use flexbox for better responsiveness */\n    flex-direction: row;\n    flex-wrap: nowrap; /* Prevents elements from wrapping */\n    align-items: flex-start;\n    position: fixed;\n    margin-top: 30px;\n    background: rgb(34, 31, 31);\n    border-radius: 20px;\n  }\n  \n  /* Right Sidebar */\n  .uac-left-sidebar-container {\n    grid-area: left;\n    border-radius: 10px;\n    margin-top: -10px;\n    margin-left: 10px;\n    height: 750px;\n    max-height: 1000vh;\n    width: 500px;\n    position: fixed;\n    background: black;\n  \n    /* ✅ boundary line */\n    border: 2px solid white;\n  \n    /* optional glow effect */\n    box-shadow: 0 0 8px rgba(255, 255, 255, 0.4);\n  }\n  \n  .uac-popover-middle-container {\n    /* grid-area: middle; */\n    grid-template-rows: 80px auto;  /* Header + Content */\n    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */\n    background: none;\n    margin-top: -10px;\n    width: 670px;\n    height: 750px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 20px;\n    margin-left: 520px;\n    position: fixed;\n    background: black;\n  }\n    \n    /* Responsive Design */\n    @media (max-width: 900px) {\n      .page-grid {\n        grid-template-areas:\n          \"top\"\n          \"middle\"\n          \"left\"\n          \"right\";\n        grid-template-columns: 1fr;\n        grid-template-rows: 80px auto auto auto;\n      }\n    }\n\n    /* Profile Section - Fixed at the Top */\n.uac-profile-section {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: none;\n  display: flex;\n  align-items: left;\n  border-radius: 10px;\n  margin-top: 0px;\n  background: none;\n  margin-left: 20px;\n}\n\n/* Profile Picture */\n.uac-profile-pic {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-left: 10px;\n  margin-top: 20px;\n}\n\n/* User Name */\n.uml-profile-name {\n  font-size: 20px;\n  font-weight: normal;\n  margin-left: 20px;\n  margin-top: 30px;\n}\n\n/* Search Bar */\n.uac-search-bar {\n  width: 500px;\n  padding: 10px;\n  background: none;\n  border-bottom: 1px solid #ddd;\n}\n\n.uac-conversations-history {\n  /* flex: 1; */\n  overflow-y: scroll;\n  padding: 16px;\n  height: 560px;\n  border-radius: 10px;\n  border-right: 2px solid darkslategray;\n}\n\n/* Input Box */\n.uac-message-input {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  /* padding: 10px; */\n  border-top: 1px solid #ccc;\n  background: none;\n  margin-bottom: 100px;\n  width: 670px;\n  height: 130px;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
